export default "__VITE_ASSET__rF2pZmpZ__"